import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import { EncrDecrService } from './../../services/encr-decr.service';
import { SoaImageService } from './../../services/soa-image.service';
declare var $: any;

@Component({
  selector: 'app-file-merge',
  templateUrl: './file-merge.component.html',
  styleUrls: ['./file-merge.component.css']
})
export class FileMergeComponent implements OnInit {
  user_id: any = '';
  company_id: any = '';
  APIKEY: any = '';
  folderid: any = '';
  folderFileList: any = '';
  xyz: any = '123';
  loaderMode: boolean = false;
  new_assign_nostamp: any = 0;
  new_fact_status: any;
  folderid_encrypt: any;
  isInvoiceCreated: any = false;

  constructor(
    private _router: Router,
    private toastr: ToastrService,
    private _activatedroute: ActivatedRoute,
    private EncrDecr: EncrDecrService,
    private SoaImageService: SoaImageService,) { }

  ngOnInit() {
    this.user_id = localStorage.getItem('id');
    this.company_id = localStorage.getItem('company_id');
    this.APIKEY = localStorage.getItem('APIKEY');

    this._activatedroute.params.subscribe(params => {
      this.folderid = this.EncrDecr.get(localStorage.getItem('key'), params['id']);
      this.folderid_encrypt = params['id'];
    });

    this.getcustomerfolderdetail(this.folderid);
    this.getFolderFile(this.folderid, 'all');

    this.xyz = localStorage.getItem('image64data');
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      company_id: this.company_id,
      data64: this.xyz,
    }
    this.saveCaptureScreen(fileModal)

    ///localStorage.removeItem('image64data');  
    $(function () {
      $("#sortable1, #sortable2").sortable({
        connectWith: ".connectedSortable"
      }).disableSelection();

      $("#sortable1, #sortable3").sortable({
        connectWith: ".connectedSortable"
      }).disableSelection();

      $('#checkImageAll').click(function () {
        if ($(this).prop("checked") == true) {
          $('.checkImageAllOpn').prop("checked", true);
        }
        else if ($(this).prop("checked") == false) {
          $('.checkImageAllOpn').prop("checked", false);
        }
      });

    });

  }

  /*
  * Edited by deepak on 16may2022
  * For check invoice created or not by if else condition
  */
  getcustomerfolderdetail(folder_id) {
    const fileModal = {
      APIKEY: this.APIKEY,
      folder_id: folder_id,
      user_id: this.user_id,
    }
    this.SoaImageService.getcustomerfolderdetail(fileModal)
      .subscribe(
        res => {
          console.log('getcustomerfolderdetail res ', res);
          this.new_fact_status = res.data.assign_fact;
          this.new_assign_nostamp = res.data.assign_nostamp;

          if (res.data.invoice_number_item == '' || res.data.invoice_number_item == null) {
            this.isInvoiceCreated = true;
          } else {
            this.isInvoiceCreated = false;
          }
          // console.log('getcustomerfolderdetail isInvoiceCreated ' , this.isInvoiceCreated) ; 
        },
      );
  }

  redirectToCreateInvoice() {
    this._router.navigateByUrl('/mobile/edit-mobile/' + this.folderid_encrypt);
  }


  deleteFile(id, type) {
    var div = id + '-' + type;
    $("#" + div).css("display", "none");
  }

  saveCaptureScreen(data) {
    this.SoaImageService.companyStamp(data)
      .subscribe(
        res => {
          //console.log(res);
          //$('#sortable1').html('');
          //this.folderFileList=res;
        },
      );
  }

  dragall() {
    if ($('#sortable2').html().trim() != '') {
      $('#sortable1').append($('#sortable2').html());
      $("#sortable2 .imagefile").css("display", "none");
      $("#sortable2 .docfile").css("display", "none");
    }
  }

  reverseall(folderid, type) {
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      folder_id: this.folderid,
      type: type,
      company_id: this.company_id,
    }
    //console.log(this.folderid);

    this.SoaImageService.getFolderFileList1(fileModal)
      .subscribe(
        res => { // console.log(res);
          $('#sortable1').html('');
          this.folderFileList = res;
        },
      );
  }

  getFolderFile(folderid, type) {
    this.loaderMode = true;
    const fileModal = {
      APIKEY: this.APIKEY,
      user_id: this.user_id,
      folder_id: this.folderid,
      type: type,
      company_id: this.company_id,
    }

    this.SoaImageService.getFolderFileList1(fileModal)
      .subscribe(
        res => {
          // console.log(res);
          // $('#sortable1').html('');
          this.loaderMode = false;
          this.folderFileList = res;
        },
      );
  }


  filterFolderFile(id, type) {
    if (type == 'image') {
      $("#sortable2 .imagefile").css("display", "block");
      $("#sortable2 .docfile").css("display", "none");
    }
    else if (type == 'document') {
      $("#sortable2 .imagefile").css("display", "none");
      $("#sortable2 .docfile").css("display", "block");
    }
    else {
      $("#sortable2 .docfile").css("display", "block");
      $("#sortable2 .imagefile").css("display", "block");

      $("#sortable2 .folderfile").css("display", "block");

    }
  }
  folderid_enc: any;

  //merging button code 
  mergeFile() {
    this.loaderMode = true;
    var all_select_file_array = [];
    var select_file_array = [];
    // var n=0;
    // create imgae to pdf code here 
    var file_array = [];
    var merge_file_array = [];
    $("#sortable1 li .folderfile").each(function () {
      var idvalue = $(this).attr('id');
      var splitted = idvalue.split("-");
      if ($(this).css('display') != 'none') {
        // var idvalue= $(this).attr('id');
        // var splitted = idvalue.split("-"); 
        if (splitted[1] == 'image') {
          file_array.push(idvalue);
        }
        merge_file_array.push(splitted[0]);
      }
    });

    //console.log('merge_file_array' ,merge_file_array) ;

    $("#sortable1 li .checkImageAllOpn:checked").each(function () {
      if ($(this).parent().parent().parent().parent().parent().css('display') != 'none') {
        select_file_array.push($(this).val());
      }
    });

    //console.log('select_file_array ' , select_file_array);
    //console.log('new_fact_status ' , this.new_fact_status);

    //  if(select_file_array.length==0 ){
    //     if(this.new_fact_status==1){ 
    //         alert('The Customer is Assigned to Factoring and at least one image must have the notice of assignment stamp');
    //         this.loaderMode=false;
    //         return false;
    //     }
    //     else{
    //       this.loaderMode=true;
    //     }
    //   }

    $("#sortable1 li .checkImageAllOpn").each(function () {
      if ($(this).parent().parent().parent().parent().parent().css('display') != 'none') {
        all_select_file_array.push($(this).val());
      }
    });

    //console.log('select_file_array.length ' , select_file_array.length);
    //console.log('file_array ' , file_array);
    //console.log('file_array ' , file_array.length);

    //if(select_file_array.length>0){

    for (let id of file_array) {
      const fileModal = {
        APIKEY: this.APIKEY,
        user_id: this.user_id,
        folder_id: this.folderid,
        company_id: this.company_id,
        file_id: id,
      }

      this.SoaImageService.convertImageToPdf(fileModal)
        .subscribe(
          res => {
            //console.log('convertImageToPdf.status ' , res.status);
            //console.log('convertImageToPdf ' , res);
          },
        );
    }

    this.applyWatermark(merge_file_array, select_file_array, all_select_file_array);

    //  }

    //////end image to pdf 
  }


  applyWatermark(merge_file_array, select_file_array, all_select_file_array) {
    //console.log('applyWatermark merge_file_array ' , merge_file_array) ;
    //console.log('applyWatermark select_file_array ' , select_file_array) ;
    //console.log('applyWatermark all_select_file_array ' , all_select_file_array) ;

    this.loaderMode = true;

    setTimeout(() => {
      for (let checkid of select_file_array) {
        // alert(checkid);
        const fileModal = {
          APIKEY: this.APIKEY,
          user_id: this.user_id,
          folder_id: this.folderid,
          company_id: this.company_id,
          type: 'checked',
          file_id: checkid,
        }

        this.SoaImageService.applyWaterMark(fileModal)
          .subscribe(
            res => {
              //console.log('applyWaterMark select' , res);
            },
          );
      }
    }, 1000);

    setTimeout(() => {
      var item = select_file_array;

      //console.log('item ' , item) ;

      var oldItems = all_select_file_array;

      //console.log('oldItems ' , oldItems) ;

      oldItems = oldItems.filter(function (n) { return item.indexOf(n) > -1 ? false : n; });
      for (let checkid of oldItems) {
        // alert(checkid);
        const fileModal = {
          APIKEY: this.APIKEY,
          user_id: this.user_id,
          folder_id: this.folderid,
          company_id: this.company_id,
          file_id: checkid,
          type: 'notchecked',
        }

        this.SoaImageService.applyWaterMark(fileModal)
          .subscribe(
            res => {
              //console.log('applyWaterMark old' , res); 
            },
          );

      }
    }, 1500);

    setTimeout(() => {
      const mergeModal = {
        APIKEY: this.APIKEY,
        user_id: this.user_id,
        folder_id: this.folderid,
        company_id: this.company_id,
        file_id: merge_file_array,

      }
      this.SoaImageService.mergningFile(mergeModal)
        .subscribe(
          res => {
            this.loaderMode = false;
            // console.log(res);
            if (res.url != '') {
              //var newWindow = window.open(res.url);
              //  this.folderid_enc = this.EncrDecr.set(localStorage.getItem('key'), this.folderid);
              //  this._router.navigateByUrl('/mobile/edit-mobile/' + this.folderid_enc);
              this._router.navigateByUrl('/mobile/email-files-factoring/' + this.folderid_encrypt);
            }

          },
        );
    }, 2700);


    /*setTimeout(()=>{    
      this.loaderMode = false;
    }, 3200);*/

  }

  redirectedinto(folderid) {
    var encrypted = this.EncrDecr.set(localStorage.getItem('key'), folderid);
    this._router.navigate(["/mobile/edit-mobile/" + encrypted]);
  }




  ///////end 

}
